const ButtonProjectCard = ({
    className,
    projectType,
    fundingPercentage,
}) => {
    let finalClass = "inline-block rounded-md text-center text-bold text-white  ";
    let content = "";
    const enCoursClass = "bg-secondary ";

    if (fundingPercentage < 100) {
        finalClass += enCoursClass;
        if (projectType === "avenir") {
            content = "Découvrir";
        } else {
            content = "Prêter";
        }
    } else {
        switch (projectType) {
            case "encours":
                finalClass += "bg-green-600 ";
                content = "Financé";
                break;
            case "termine":
            case "rembourse":
                finalClass += "bg-green-600 ";
                content = "Clôturé";
                break;
            default:
                if (process.env.NODE_ENV === "development") {
                    console.error("ButtonProjectCard: projectType incorrect:", projectType);
                }
                finalClass += "bg-green-600 ";
                content = "Clôturé";
                break;
        }

    }

    finalClass += className;

    if (!content) {
        return null;
    }

    return <span className={finalClass}>{content}</span>;
}
export default ButtonProjectCard;